import React from "react";
import { Link } from "react-router-dom";
import {
  ArrowForwardRounded,
  ArticleOutlined,
  AssignmentTurnedInOutlined,
  BusinessCenterOutlined,
  CheckCircleOutlineRounded,
  GroupsOutlined,
  LocationOnOutlined,
  ShieldOutlined,
  WorkOutlineRounded,
} from "@mui/icons-material";
import "./Careers.css";

const TERMS_URL = "/career/field-development-consultant/fdc-policy";

const process = [
  {
    title: "Read the position terms",
    description: "Review the FDC employment, performance and career progression framework.",
  },
  {
    title: "Complete your application",
    description: "Open the seven-stage online form and prepare the requested documents.",
  },
  {
    title: "Await recruitment review",
    description: "Your submission is recorded as an applicant, pending an authorized decision.",
  },
];

export default function Careers() {
  return (
    <main className="careerHub">
      <div className="careerHub__shell">
        <nav className="careerHub__breadcrumb" aria-label="Breadcrumb">
          <Link to="/">Home</Link>
          <span aria-hidden="true">/</span>
          <span>Careers</span>
        </nav>

        <header className="careerHub__hero">
          <div className="careerHub__hero-copy">
            <span className="careerHub__eyebrow"><span className="careerHub__eyebrow-dot" /> UNIVERSE TECH INDUSTRY · CAREERS</span>
            <h1>Grow with <span>Universe Inventory.</span></h1>
            <p>
              Help more businesses adopt smarter ways to manage their inventory, sales and operations.
              Explore current career opportunities and learn how to apply.
            </p>
            <div className="careerHub__hero-actions">
              <a className="careerHub__button careerHub__button--primary" href="#openings">
                Explore open positions <ArrowForwardRounded aria-hidden="true" />
              </a>
              <a className="careerHub__button careerHub__button--quiet" href="#application-process">
                How applications work
              </a>
            </div>
          </div>
          <aside className="careerHub__hero-side" aria-label="Recruitment overview">
            <div className="careerHub__side-top"><BusinessCenterOutlined aria-hidden="true" /> Recruitment overview</div>
            <div className="careerHub__side-feature">
              <span className="careerHub__live"><span /> APPLICATIONS OPEN</span>
              <strong>Field Development Consultant</strong>
              <span>Business Development / Client Acquisition</span>
            </div>
            <div className="careerHub__side-bottom">
              <div><CheckCircleOutlineRounded aria-hidden="true" /> Online application available</div>
              <div><ShieldOutlined aria-hidden="true" /> Applications reviewed before staff onboarding</div>
            </div>
          </aside>
        </header>

        <section className="careerHub__section" id="openings" aria-labelledby="career-openings-title">
          <div className="careerHub__section-header">
            <div>
              <span className="careerHub__section-kicker">CURRENT OPPORTUNITIES</span>
              <h2 id="career-openings-title">Open positions</h2>
              <p>Explore roles currently accepting applications at Universe Inventory Management System.</p>
            </div>
            <span className="careerHub__opening-count">1 position accepting applications</span>
          </div>

          <article className="careerHub__opening">
            <div className="careerHub__opening-main">
              <div className="careerHub__opening-heading">
                <span className="careerHub__role-icon"><WorkOutlineRounded aria-hidden="true" /></span>
                <div>
                  <div className="careerHub__opening-label"><span className="careerHub__status-dot" /> Applications open</div>
                  <h3>Field Development Consultant <span>(FDC)</span></h3>
                </div>
              </div>
              <p>
                Introduce businesses to the Universe Inventory platform, guide qualified prospects through
                registration and subscription, and support successful client activation and adoption.
              </p>
              <div className="careerHub__role-details">
                <span><GroupsOutlined aria-hidden="true" /> Business Development</span>
                <span><LocationOnOutlined aria-hidden="true" /> Assigned territories in Nigeria</span>
                <span><ArticleOutlined aria-hidden="true" /> Terms available to review</span>
              </div>
            </div>
            <div className="careerHub__opening-actions">
              <span>Start by reviewing the FDC terms of service.</span>
              <Link className="careerHub__button careerHub__button--primary" to={TERMS_URL}>
                View position &amp; apply <ArrowForwardRounded aria-hidden="true" />
              </Link>
            </div>
          </article>
          <p className="careerHub__openings-note">
            Only positions shown as open are accepting applications here. An application is not an offer of employment.
          </p>
        </section>

        <section className="careerHub__section careerHub__process" id="application-process" aria-labelledby="career-process-title">
          <div className="careerHub__section-header">
            <div>
              <span className="careerHub__section-kicker">YOUR APPLICATION JOURNEY</span>
              <h2 id="career-process-title">A clear path from interest to review</h2>
              <p>Review the role, submit the application and retain the confirmation reference.</p>
            </div>
          </div>
          <div className="careerHub__steps">
            {process.map((item, index) => (
              <article className="careerHub__step" key={item.title}>
                <span className="careerHub__step-number">{String(index + 1).padStart(2, "0")}</span>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </article>
            ))}
          </div>
          <div className="careerHub__process-note">
            <AssignmentTurnedInOutlined aria-hidden="true" />
            <p><strong>After you submit:</strong> Your application is saved for recruitment review. Staff access, appointments and assignment approvals are not created automatically.</p>
          </div>
        </section>
      </div>
    </main>
  );
}
